import { State as AppServerState } from "../core/AppServer";
import { PaneDataByDataId } from "../stores/PaneDataStore";
import BaseService from "./BaseService";

export interface OnDialogOpenResponse {
  appServerState: AppServerState;
  dialogLayoutId: number;
  paneDataByDataId: PaneDataByDataId;
}

export default class ComplexResultsGridControlService {
  public static async onDialogOpen(
    rowKey: string,
    dataId: string,
    widgetName: string,
    dialogRowKey: string
  ): Promise<OnDialogOpenResponse> {
    return BaseService.requestObject<OnDialogOpenResponse>(
      `ComplexResultsGridControl/OnDialogOpen/${rowKey}/${dataId}/${widgetName}`,
      null,
      null,
      {
        dialogRowKey,
      },
      "POST"
    );
  }
}
